var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0312 8.4624H24.0312V2.4624",
    stroke: "#343434",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7813 19.775C18.2433 21.3143 16.2833 22.3628 14.1493 22.788C12.0153 23.2132 9.80307 22.9958 7.79256 22.1635C5.78205 21.3312 4.06355 19.9213 2.85446 18.1122C1.64536 16.3031 1 14.176 1 12C1 9.82403 1.64536 7.69693 2.85446 5.8878C4.06355 4.07866 5.78205 2.66877 7.79256 1.83647C9.80307 1.00417 12.0153 0.786859 14.1493 1.21202C16.2833 1.63719 18.2433 2.68573 19.7813 4.22501L24.0313 8.4625",
    stroke: "#343434",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.05c1f95e4503e5973a3b413ba4a3c6ca.svg";
export { ForwardRef as ReactComponent };